import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Card from '../../../components/ui/Card';
import { docsSections } from '../../../components/layout/DocsLayout';

const DocsIndex: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Documentation — Sprout</title>
        <meta
          name="description"
          content="Sprout documentation: getting started guides, security and POPIA compliance, data export, and CAPS curriculum alignment."
        />
        <link rel="canonical" href="https://sprout-ui-pi.vercel.app/docs" />
      </Helmet>

      <header className="not-prose mb-10">
        <h1 className="text-4xl font-display font-bold text-gray-900 dark:text-white">
          Documentation
        </h1>
        <p className="mt-3 text-lg text-gray-600 dark:text-gray-300 max-w-2xl">
          Practical guides for getting started with Sprout, plus straightforward
          answers about how we handle your school's data.
        </p>
      </header>

      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-6">
        {docsSections.map(section => (
          <Card key={section.title} className="!p-6">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              {section.title}
            </h2>
            <ul className="mt-4 space-y-2">
              {section.links.map(link => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>

      <section className="not-prose mt-12 p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Can't find what you're looking for?
        </h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          Email <a className="text-primary-600 dark:text-primary-400" href="mailto:hello@sprout.education">hello@sprout.education</a>{' '}
          or visit our{' '}
          <Link to="/contact" className="text-primary-600 dark:text-primary-400">
            contact page
          </Link>
          .
        </p>
      </section>
    </>
  );
};

export default DocsIndex;
